import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Header from '../components/Header';
import Footer from '../components/Footer';

const { FiCheck, FiHome } = FiIcons;

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      
      <main className="flex-grow flex items-center justify-center py-20 px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl w-full bg-white rounded-lg shadow-xl p-10 text-center"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 text-green-600 rounded-full mb-8">
            <SafeIcon icon={FiCheck} className="w-10 h-10" />
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Thank You!</h1>
          
          <p className="text-xl text-gray-600 mb-10">
            We've received your submission and will get back to you shortly.
          </p>
          
          <Link to="/">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors duration-300"
            >
              <SafeIcon icon={FiHome} className="w-5 h-5 mr-2" />
              Return to Home
            </motion.button>
          </Link>
        </motion.div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ThankYouPage;